import { useMutation, useQueryClient } from '@tanstack/react-query';
import { attachmentApiClient } from 'src/api/FiretrolApiClientInstances';
import { invalidateFor } from 'src/api/queries/invalidationMap';

/** @registry Persists the inline description on a workflow record's attachment. */
export function useUpdateAttachmentComment() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({
      attachmentId,
      comment,
    }: {
      jobId: number;
      attachmentId: string;
      comment: string;
    }) => attachmentApiClient.updateComment(attachmentId, { comment }),
    meta: { errorContext: 'attachment comment' },
    onSettled: (_data, _err, { jobId }) =>
      invalidateFor('workflowEntity.attachment', qc, { jobId }),
  });
}

/** @registry Uploads a file to temporary storage for a workflow record's FileDrop. */
export function useUploadTempAttachment() {
  return useMutation({
    mutationFn: ({ typeId, file }: { typeId: string; file: File }) =>
      attachmentApiClient.uploadTempFile(typeId, {
        data: file,
        fileName: file.name,
      }),
    meta: { errorContext: 'temp attachment upload' },
  });
}
